import React, { useState, useEffect } from 'react';
import './DynamicReviewForm.css';
import useLocale from '../hooks/useLocale';

const DynamicReviewForm = ({
  template,
  formValues: externalValues,
  onChange,
  editable = false,
}) => {
  const { getCurrentLanguage } = useLocale();
  const lang = getCurrentLanguage();

  const getInitialValues = () => {
    const init = {};
    template.forEach((block) => {
      init[block.id] = '';
    });
    return init;
  };

  const [internalValues, setInternalValues] = useState(getInitialValues());

  useEffect(() => {
    setInternalValues(getInitialValues());
  }, [template]);

  const values = externalValues || internalValues;

  const handleFieldChange = (block_id, value) => {
    const newValues = { ...values, [block_id]: value };
    if (onChange) {
      onChange(newValues);
    } else {
      setInternalValues(newValues);
    }
  };

  return (
    <div className="dynamic-review-form">
      {template.map((block) => {
        if (block.type === 'select') {
          return (
            <div key={block.id} className="dynamic-form-block">
              <label className="dynamic-form-label">
                {block.label}
                {block.required !== false ? (
                  <span className="dynamic-form-required-asterisk"> *</span>
                ) : (
                  <span className="dynamic-form-optional-indicator">
                    {lang === 'ru' ? ' (необязательно)' : ' (optional)'}
                  </span>
                )}
                <select
                  className="dynamic-form-select"
                  value={values[block.id] || ''}
                  onChange={
                    editable ? (e) => handleFieldChange(block.id, e.target.value) : undefined
                  }
                  disabled={!editable}
                >
                  {/* Keep an explicit empty option:
                      - required: disabled so user must choose
                      - optional: enabled so user can leave it empty / clear selection
                  */}
                  <option value="" disabled={block.required !== false ? true : false}>
                    {editable ? (lang === 'ru' ? '-- Выберите --' : '-- Select --') : '—'}
                  </option>

                  {block.options.map((opt, i) => (
                    <option key={i} value={opt.id}>
                      {opt.label}
                    </option>
                  ))}
                </select>
              </label>
            </div>
          );
        } else if (block.type === 'textarea') {
          return (
            <div key={block.id} className="dynamic-form-block">
              <label className="dynamic-form-label">
                {block.label}
                {block.required !== false ? (
                  <span className="dynamic-form-required-asterisk"> *</span>
                ) : (
                  <span className="dynamic-form-optional-indicator">
                    {lang === 'ru' ? ' (необязательно)' : ' (optional)'}
                  </span>
                )}
                <textarea
                  className="dynamic-form-textarea"
                  value={values[block.id] || ''}
                  onChange={
                    editable ? (e) => handleFieldChange(block.id, e.target.value) : undefined
                  }
                  readOnly={!editable}
                />
              </label>
            </div>
          );
        }
        return null;
      })}
    </div>
  );
};

export default DynamicReviewForm;
